import { TableProps } from "antd";
import { IInvoiceUserList } from "./types";
import { IndianformatDate } from "./Mapper";

export const getColumns = (): TableProps<IInvoiceUserList>["columns"] => [
	// {
	// 	title: "ID",
	// 	dataIndex: "id",
	// 	key: "id",
	// 	sorter: true
	// },
	{
		title: "Register Email",
		dataIndex: "registerEmail",
		key: "registerEmail",
		sorter: true
	},
	{
		title: "Business Name",
		dataIndex: "businessName",
		key: "businessName",
		sorter: true
	},
	{
		title: "Business Email",
		dataIndex: "businessEmail",
		key: "businessEmail",
		sorter: true
	},
	{
		title: "Role Name",
		dataIndex: "roleName",
		key: "roleName",
		sorter: true
	},
	{
		title: "Profile Created",
		dataIndex: "creatorProfileCreated",
		key: "creatorProfileCreated",
		render: (value: boolean) => value ? "Yes" : "No",
		sorter: true
	},
	{
		title: "Created Date",
		dataIndex: "createdDate",
		key: "createdDate",
		render: (date: string) => IndianformatDate(date),
		sorter: true
	}
];
